module.exports = __webpack_public_path__ + "static/media/arrow-prev.39799dc2.svg";